import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.running = false
    this.handler = () => this.startAnimation()
    document.addEventListener("sabor-bet:win", this.handler)
  }

  disconnect() {
    document.removeEventListener("sabor-bet:win", this.handler)
    this.cleanup()
  }

  async startAnimation() {
    if (this.running) return
    this.running = true

    const THREE = await import("three")

    const canvas = document.createElement("canvas")
    canvas.className = "cheese-rain-canvas"
    document.body.appendChild(canvas)

    const width = window.innerWidth
    const height = window.innerHeight

    const renderer = new THREE.WebGLRenderer({ canvas, alpha: true, antialias: true })
    renderer.setSize(width, height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

    const scene = new THREE.Scene()
    const camera = new THREE.PerspectiveCamera(60, width / height, 0.1, 100)
    camera.position.z = 20

    scene.add(new THREE.AmbientLight(0xffffff, 0.6))
    const dirLight = new THREE.DirectionalLight(0xffffff, 0.8)
    dirLight.position.set(5, 10, 7)
    scene.add(dirLight)

    const colors = [0xFFC107, 0xFFB300, 0xFF9800, 0xFFE082]
    const cheeses = []

    for (let i = 0; i < 40; i++) {
      const geo = new THREE.CylinderGeometry(0.8, 0.8, 0.3, 6)
      const mat = new THREE.MeshStandardMaterial({ color: colors[i % colors.length] })
      const mesh = new THREE.Mesh(geo, mat)

      mesh.position.set(
        (Math.random() - 0.5) * 30,
        15 + Math.random() * 15,
        (Math.random() - 0.5) * 10
      )

      mesh.rotation.set(Math.random() * Math.PI, Math.random() * Math.PI, Math.random() * Math.PI)

      const speed = 0.08 + Math.random() * 0.12
      const wobbleAmp = 0.02 + Math.random() * 0.03
      const wobbleFreq = 2 + Math.random() * 3
      const rotSpeed = { x: (Math.random() - 0.5) * 0.06, y: (Math.random() - 0.5) * 0.06, z: (Math.random() - 0.5) * 0.06 }

      cheeses.push({ mesh, speed, wobbleAmp, wobbleFreq, rotSpeed })
      scene.add(mesh)
    }

    let frame = 0
    const totalFrames = 180

    const animate = () => {
      if (frame >= totalFrames) {
        this.cleanup()
        return
      }

      frame++

      cheeses.forEach((c, i) => {
        c.mesh.position.y -= c.speed
        c.mesh.position.x += Math.sin(frame * 0.05 * c.wobbleFreq) * c.wobbleAmp
        c.mesh.rotation.x += c.rotSpeed.x
        c.mesh.rotation.y += c.rotSpeed.y
        c.mesh.rotation.z += c.rotSpeed.z
      })

      // Fade out nos ultimos 30 frames
      if (frame > totalFrames - 30) {
        const opacity = (totalFrames - frame) / 30
        canvas.style.opacity = opacity
      }

      renderer.render(scene, camera)
      this.animId = requestAnimationFrame(animate)
    }

    this.renderer = renderer
    this.scene = scene
    this.canvas = canvas
    this.cheeses = cheeses
    this.animId = requestAnimationFrame(animate)
  }

  cleanup() {
    if (this.animId) cancelAnimationFrame(this.animId)

    if (this.cheeses) {
      this.cheeses.forEach(c => {
        c.mesh.geometry.dispose()
        c.mesh.material.dispose()
      })
    }

    if (this.renderer) {
      this.renderer.dispose()
      this.renderer = null
    }

    if (this.canvas && this.canvas.parentNode) {
      this.canvas.remove()
    }

    this.scene = null
    this.cheeses = null
    this.canvas = null
    this.running = false
  }
}
